<template>
    
    <div id="dvtop">   
        <centralnotificacao></centralnotificacao>        
	        <nav id="navbarmenu" class="navbar navbar-expand-md navbar-dark draco-topbar">
            <button type="button" class="btn btn-link btn-menu-toggle" aria-label="Abrir menu" @click.prevent="toggleNav">
                <i class="fa" :class="isSidenavOpen ? 'fa-times' : 'fa-bars'"></i>
            </button>
            <span id="fantasia-filial">{{ filial.fantasia }}</span>
            <div class="collapse navbar-collapse" id="collapsibleNavbar">
                <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
                </ul>
            </div>
            <span class="navbar-text">
                <ul id="lst-icones-menu-nav">
                    <!-- <li>
                        <span class="icone-menu-bar" @click.prevent="mtdcentralnotificacao()" title="Central de notificações"><i class="fa fa-flag"></i></span>                        
                    </li>  -->
                    <li>
                        <div class="dropdown">
                            <span class="icone-menu-bar" aria-expanded="false" title="Notificações" data-toggle="dropdown">
                                <span class="bolinha-notificacao">
                                    <i style="font-size: 14px;" class="fa fa-bell"></i>
                                    <span v-show="qtdnotificacoes > 0" style="    top: 26px;
    left: -14px;" class="badge badge-pill badge-danger badge-notfusu">{{qtdnotificacoes}}</span>
                                </span>
                                
                            </span>
                            <div v-show="qtdnotificacoes > 0" class="dropdown-menu drop-notificacoes animate slideIn">
                                <div class="container-fluid" style="padding: 0px;">
                                    <ul class="list-group" style="width: 100%;">
                                        <li class="list-group-item" active>
                                            <i class="fa fa-bell"></i> Notificações
                                            <span id="limpar-notificacao" @click.prevent="mtdlimparnotificacoes(0)">Limpar tudo</span>
                                        </li>
                                        <div style="max-height: 273px; overflow: auto;">
                                            <li v-for="(notificacao, indice) in lstnotificacoes" :key="indice" @click.prevent="mtddetalhesnotificacao(notificacao)" class="list-group-item list-group-item-action" style="padding-bottom: 20px; cursor: pointer;">
                                                <template v-if="parseInt(notificacao.tipo) === 1">
                                                    <span><i class="fa fa-certificate" style="font-size: 22px; color: #f82b54;"></i></span>
                                                </template>                                            
                                                <template v-else>
                                                    <img  v-bind:src="pathfotos+notificacao.foto" class="img-usutarefa img-usuario-notificacao" data-toggle="tooltip" v-bind:title="'Registrada por: '+notificacao.nomeusu">
                                                </template>
                                                <span class="tit-notificacao" v-bind:title="notificacao.descnotificacao">{{ notificacao.descnotificacao }}</span>
                                                <span class="data-notificacao">{{ notificacao.dtemissao }}</span>
                                            </li>

                                            <!-- <li v-for="(titulo, indice) in lstBoletosDisp" :key="indice" class="list-group-item list-group-item-action" style="padding-bottom: 20px;">
                                                
                                                <span v-if="titulo.diretoriotitulo===''||titulo.diretoriotitulo===null"><i class="fa fa-qrcode"  style="font-size: 22px; margin-top: 10px; margin-left: 5px; cursor: pointer;" @click.prevent="mtdpagamentopix(titulo)" title="Pagar via PIX"></i></span>
                                                <span v-else><i class="fa fa-barcode" style="font-size: 22px; color: #0acf97; margin-top: 10px;  cursor: pointer;" @click.prevent="mtdimprimirboleto(titulo)" title="Pagar via boleto"></i></span>
                                                <span class="tit-notificacao"  style="left: 75px;">Fatura disponível</span>
                                                <span class="data-notificacao" style="left: 75px;">Vencimento: {{ titulo.dtventit }}</span>
                                            </li> -->

                                            <li v-for="(titulo, indice) in titulopagar" :key="indice" class="list-group-item list-group-item-action" style="padding-bottom: 20px;">
                                                
                                                <span><i class="fa fa-qrcode"  style="font-size: 22px; margin-top: 10px; margin-left: 5px; cursor: pointer;" @click.prevent="goToCasualPayment()"></i></span>
                                                <span class="tit-notificacao"  style="left: 75px;">Fatura disponível({{ formatarData(titulo.dtventit) }})</span>
                                                <span class="data-notificacao" style="left: 75px;">{{ titulo.codtit }}</span>
                                            </li>
                                        </div>
                                    </ul>
                                </div>
                            </div>                            
                        </div>
                    </li>
                    <!-- <li>
                        <span class="icone-menu-bar" @click.prevent="mtdlogoff()" title="Sair">
                            <span class="bolinha-notificacao"><i class="fa fa-sign-out"></i>
                            </span>
                        </span>                        
                    </li> -->
                </ul>
	            </span>            
	        </nav>
            <div class="draco-top-divider"></div>
	        <div v-if="isSidenavOpen && isMobileViewport" class="draco-sidenav-backdrop" @click.prevent="closeNav"></div>
        <div id="mySidenav" @mouseleave="handleSidenavMouseLeave" class="sidenav">
            <div id="dvconteudo-side-nav" class="container-fluid" style="display: none;">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 dv-borda-bottom">
                        <img class="img-fluid sidenav-logo" :src="logoFilialMenu" alt="Logo da filial">
                        <span href="#" class="closebtn" @click.prevent="closeNav">&times;</span>                        
                    </div>
                    <div class="col-md-12 dv-borda-bottom draco-side-shortcuts">
                        <router-link to="/" class="draco-side-home-link" @click.native="closeNav">
                            <i class="fa fa-home"></i> Início
                        </router-link>
                    </div>
                    <div class="col-md-12 dv-borda-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="input-group">
                                    <input type="text" class="form-control" id="edpesquisamenu" v-model="vcontpesqrapida" placeholder="Pesquisar..." autocomplete="off">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="btpesquisarmenu">
                                        <i class="fa fa-search" aria-hidden="true"></i>
                                    </span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="lstlistaresultado.length > 0" class="col-md-12" style="margin-top: 2px;">
                                <ul class="grupo-lista-pesquisa" style="margin-bottom: 0px;">
                                    <li v-for="(item, index) in lstlistaresultado" v-bind:key="index" style="list-style-type: none; padding: 0px; min-height: 20px;">
                                        <router-link v-bind:to="item.link">{{ mtdformatarnomemenu(item.menu) }}</router-link>
                                    </li>
                                </ul>
                            </div>                        
                        </div>
                    </div>
                    <div class="col-md-12 dv-borda-bottom" style="padding-top: 5px;">
                        <div class="row">
                            <div class="col-md-12">
                                <h6 style="font-size: 12px; font-weight: bold; color: #2c5569;">MENU</h6>
                            </div>
                            <div class="col-md-12" style="padding: 0px; margin-bottom: -16px;">
                                <ul v-show="menuindividual.length >= 0" id="grupo-lista-menu">
                                    <template v-for="(menu, index) in menuindividual">
                                        <li v-if="parseInt(menu.habilita) === 1" v-bind:key="index">
                                            <a data-toggle="collapse" v-bind:href="'#menu'+index"><span class="icone-menu"><i v-bind:class="menu.icone"></i></span> {{ mtdformatarnomemenu(menu.menu) }}<i class="fa fa-chevron-right icone-rotate"></i></a>
                                            <ul class="grupo-lista-submenu collapse" v-bind:id="'menu'+index">
                                                <li>
                                                    <template v-for="(item, indexi) in menu.submenu">
                                                        <template v-if="item.menu !== '-'">
                                                            <router-link v-bind:key="indexi" v-if="parseInt(item.habilita) === 1" v-bind:to="item.link">{{ mtdformatarnomemenu(item.menu) }}</router-link>
                                                        </template>                                                        
                                                    </template>
                                                </li>                                            
                                            </ul>
                                        </li>
                                    </template>    
                                </ul>                                
                            </div>
                        </div>
                    </div>
                    <div style="padding-top: 30px;" class="col-12 col-sm-12 col-md-12">
                        <span class="icone-menu-bar" @click.prevent="mtdlogoff()" title="Sair">
                            SAIR 
                        </span>                        
                    </div>
                </div>
            </div>  
            <div id="dvconteudo-side-nav-mini" class="container-fluid" >
                <div class="row">
                    <!-- <div class="col-md-12" style="padding-top: 15px; padding-bottom: 15px;">
                        <div class="row">
                            <div class="col-md-12">
                                <h6 style="font-size: 12px; padding-left: 0px; font-weight: bold; color: #2c5569;">MENU</h6>
                            </div>                        
                        </div>
                    </div> -->
                    <div class="col-12 col-sm-12 col-md-12">
                        <img class="img-fluid sidenav-logo sidenav-logo--mini" :src="logoFilialMenuMini" alt="Logo da filial">
                                  
                    </div>
                    <div style="padding-top: 18px;" class="col-12 col-sm-12 col-md-12">
                    </div>
              
                    <div class="col-md-12" style="padding-top: 5px;" @mouseover="handleMiniHover" @click.prevent="openNav">
                        <div class="row">
                            
                            <div class="col-md-12" style="padding: 0px; margin-bottom: -16px;" >
                                <ul v-show="menuindividual.length >= 0" id="grupo-lista-menu">
                                    <li class="draco-mini-home-item">
                                        <router-link to="/" class="draco-mini-home-link" title="Ir para início" @click.native="closeNav">
                                            <span class="icone-menu"><i class="fa fa-home"></i></span>
                                        </router-link>
                                    </li>
                                    <template v-for="(menu, index) in menuindividual">
                                        <li v-if="parseInt(menu.habilita) === 1" v-bind:key="index">
                                            <a style="padding-left: 17px;" data-toggle="collapse" v-bind:href="'#menu'+index"><span class="icone-menu"><i v-bind:class="menu.icone"></i></span></a>
                                        </li>
                                    </template>    
                                </ul>                                
                            </div>
                        </div>
                    </div>

                    <div style="padding-top: 30px;" class="col-12 col-sm-12 col-md-12">
                        
                        <span class="icone-menu-bar" @click.prevent="mtdlogoff()" title="Sair">
                            <span class="bolinha-notificacao"><i class="fa fa-sign-out"></i>
                            </span>
                        </span>                        
                          
                    </div>
                </div>
            </div>           
        </div>
        <!-- Modal para visualização do detalhe da notificação -->
        <div class="modal fade" id="mdldetnotificacao" tabindex="-1" role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalScrollableTitle" style="font-size: 18px;"><i class="fa fa-bell"></i> {{ detnotificacao.descnotificacao }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-justify">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="jumbotron" style="margin-bottom: 0px; padding: 40px 15px 40px 15px;">
                                    <div class="row">
                                        <div class="col-md-12 text-center" style="margin-bottom: 15px;">
                                            <template v-if="parseInt(detnotificacao.tipo) === 1">
                                                <span><i class="fa fa-certificate icon-validade-cert"></i></span>
                                            </template>
                            
                                            <template v-else>
                                                <img v-if="detnotificacao.foto !== 'undefined'" v-bind:src="pathfotos+detnotificacao.foto" class="img-usutarefa img-usuario-notificacao" style="width: 60px!important; height: 60px!important;">
                                            </template>
                                        </div>
                                        <div class="col-md-12" style="margin-bottom: 10px;">
                                            <h6 v-if="parseInt(detnotificacao.tipo) === 1">Emissão: {{ detnotificacao.dtemissao }}, por Purple.</h6>                                            
                                            <h6 v-else>Emissão: {{ detnotificacao.dtemissao }}, por {{ detnotificacao.nomeusu }}.</h6>                                            
                                        </div>
                                    
                                        <div id="conteudonotif" class="col-md-12">
                                            <p>{{ detnotificacao.conteudonotificacao }}</p>                                            
                                            <p v-if="parseInt(detnotificacao.tipo) === 0"><strong>Tarefa:</strong> {{ detnotificacao.titulotarefa }}</p>                                            
                                        </div>                                                                                                                                                                               
                                    </div>
                                </div>                                
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                    </div>
                </div>
            </div>
        </div>
         <!-- Modal para visualização do detalhe da notificação personalizada - guga 🤠 -->
        <div class="modal fade" id="mdldetnotificacaouser" tabindex="-1" role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content" style="margin: -5px;">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalScrollableTitle" style="font-size: 18px;"><i :class="detnotificacao.adesivo"></i> {{ detnotificacao.descnotificacao }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-justify">
                        <div class="container-fluid">
                            <div class="row">
                                <div style="width: 100%;" class="row">
                                    <div class="col-3">
                                        <div class="col-md-12 text-center jumbotron d-flex align-items-center justify-content-center" style="padding-top: 6px; padding-bottom: 8px; border-radius: 100%; width: 68px;">
                                            <i style="font-size: 50px; " :class="detnotificacao.adesivo +' '+detnotificacao.cor"></i>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="col-md-12 text-center" style="padding-top: 20px;">
                                            <h6>{{ detnotificacao.descnotificacao }}</h6> 
                                        </div>
                                    </div>
                                    <div style="width: 100%; align-items: center;" class="col-3">
                                        <div class="row d-flex align-items-center justify-content-center">
                                            <img v-if="detnotificacao.foto !== 'undefined'" v-bind:src="pathfotos+detnotificacao.foto" class="img-usutarefa img-usuario-notificacao" style="width: 35px!important; height: 35px!important; ">
                                            <span style="font-size: 8px; text-align: center; width: 100%;">Emissão: {{ detnotificacao.dtemissao }}, por {{ detnotificacao.nomeusu }}.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="jumbotron" style="margin-bottom: 0px; padding: 40px 15px 40px 15px; width: 100%;">
                                    <div class="row">
                                        <div id="conteudonotifexp" class="col-md-12">
                                              
                                        </div>                                                                                                                                                                               
                                    </div>
                                </div>                                
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal pra redefinição de senha e foto do usuário -->
        <div class="modal fade" id="mddefinicoesusuario">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" style="font-size: 16px;">Definições do usuário</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="col-md-12 text-center border rounded" style="padding-top: 10px; padding-bottom: 10px;">
                                    <img id="img-usuario-def" class="img-thumbnail" 
                                    v-bind:src="pathfotovisualizar+usuario.foto" 
                                    data-toggle="tooltip" 
                                    title="Clique na foto para alterar" 
                                    data-placement="bottom"
                                    @click="$refs.if_imgusuariodef.click()">
                                    <div class="col-md-12 text-center">
                                        <input type="file" 
                                        accept="image/png, image/jpeg"
                                        id="btselecionarimagemusudef" 
                                        @change="mtdselecionarimagemusuariodef" 
                                        style="display: none;"
                                        ref="if_imgusuariodef">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <label for="edsenhaantigadef">Senha antiga:</label>
                                <input type="password" class="form-control form-control-sm" id="edsenhaantigadef" v-model="asenha_antiga" data-bv-group=".group" maxlength="20">
                            </div>
                            <div class="col-md-12">
                                <label for="edsenhanovadef">Nova senha:</label>
                                <input type="password" class="form-control form-control-sm" id="edsenhanovadef" v-model="asenha_nova" data-bv-group=".group" maxlength="20">
                            </div>
                            <div class="col-md-12">
                                <label for="edsenhaconfirmadef">Confirmar senha:</label>
                                <input type="password" class="form-control form-control-sm" id="edsenhaconfirmadef" v-model="asenha_repete" data-bv-group=".group" maxlength="20">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <a href="#" id="btalterarsenhausudef" class="btn btn-primary btn-sm" role="button" style="min-width: 100px;" @click.prevent="mtdalterarsenhausuario()"><i class="fa fa-check-circle"></i> Confirmar</a>
                        <a href="#" class="btn btn-secondary btn-sm" role="button" data-dismiss="modal" style="min-width: 100px;"><i class="fa fa-close"></i> Fechar</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal regualização -->
        <div class="modal fade" id="mdlregularizar" role="dialog" aria-hidden="true" data-backdrop="static">
            <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body text-justify">
                        <div class="jumbotron" style="margin-bottom: 0px;">
                            <div class="container-fluid">
                                <div class="row"> 
                                  
                                    <div class="col-md-12 text-justify">
                                        <i style="font-size: 70px; color:#f82b54" class="fa fa-ban"></i>
                                        <p style="font-size: 20px;">Atenção Caro cliente,<br>
                                            Seu sistema esta bloqueado por falta de pagamento. Aperte no botao abaixo para efeuar o seu pagamento<br>
                                        </p>
                                    </div>
                                   
                                    <div class="col-md-12 text-center">
                                        <a href="#" class="btn btn-success" @click.prevent="goToCasualPayment()">Pagar fatura</a>
                                    </div>                                               
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>       
        
        <div class="modal fade" id="mdlembretepagamento" role="dialog" aria-hidden="true" data-backdrop="static">
            <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body text-justify">
                        <div class="jumbotron" style="margin-bottom: 0px;">
                            <div class="container-fluid">
                                <div class="row"> 
                                  
                                    <div class="col-md-12 text-justify">

                                        <p style="font-size: 20px;">Atenção Caro cliente,<br>
                                            Até o momento não identificamos o pagamento de sua fatura, caso ja efetuou desconsidere<br>
                                        </p>
                                    </div>
                                   
                                    <div class="col-md-12 text-center">
                                        <a href="#" class="btn btn-success" @click.prevent="goToCasualPayment()">Pagar fatura</a>
                             
                                        <a href="#" class="btn btn-success" data-dismiss="modal"> Já paguei</a>
                                    </div>                                                  
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> 

        <div class="modal fade" id="mdfimdemo" role="dialog" aria-hidden="true" data-backdrop="static">
            <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body text-justify">
                        <div class="jumbotron" style="margin-bottom: 0px;">
                            <div class="container-fluid">
                                <div class="row"> 
                                  
                                    <div class="col-md-12 text-justify">

                                        <p style="font-size: 20px;">Querido cliente,<br>
                                            Esperamos que você tenha aproveitado seu período de teste gratuito! Queremos informá-lo que o seu período de teste terminou e para continuar desfrutando de nossos serviços, é necessário concluir o pagamento da assinatura.

Para facilitar, você pode clicar no botão abaixo para finalizar o pagamento e continuar usufruindo dos benefícios do nosso serviço:<br>
                                        </p>
                                    </div>
                                   
                                    <div class="col-md-12 text-center">
                                        <a href="#" class="btn btn-success" @click.prevent="goToFirstPayment()">Pagar fatura</a>
                                    </div>  
                                    <div class="col-md-12 text-justify">

                                        <p style="font-size: 20px;">Se tiver alguma dúvida ou precisar de ajuda, nossa equipe de suporte está à disposição para ajudar. Entre em contato pelos canais de atendimento ao cliente.

Agradecemos por escolher nossos serviços e esperamos continuar proporcionando uma excelente experiência para você!
                                        </p>
                                    </div>                                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
    </div>
</template>
<script>
    import util from '../utilitarios/util.js'
    import centralnotificacao from '../components/cmpcentralnotificacao.vue';
    export default {
        name: "menutop",
        components:{
            centralnotificacao
        },        
        data: function () {
            return {
                pathfotos           : this.$store.state.configpaths.pathimagens,
                lstpesquisa         : [],
                lstlistaresultado   : [],
                qtdnotificacoes     : 0,
                titulopagar         : [],
                lstnotificacoes     : [],
                detnotificacao      : [],
                menuapp             : [],
                menuindividual      : [],
                pathfotovisualizar  : this.$store.state.configpaths.pathimagens,
                vcontpesqrapida     : '',
                isSidenavOpen       : false,
                isMobileViewport    : window.innerWidth <= 991,
                resizeHandler       : null,

                //variáveis de liberação do sistema
                lstBoletosDisp      : [],
                diasatraso          : 0,

                //alterações de senha e foto do usuário                
                asenha_antiga       : '',
                asenha_nova         : '',
                asenha_repete       : '',
                arqimgselecionado   : '',
                vfoto               : ''
            };
        },
        methods: {
            goToFirstPayment() {
                this.$router.push({ name: 'Payment', params: { type: 'first' } });
            },
            goToCasualPayment() {
                this.$router.push({ name: 'Payment', params: { type: 'casual' } });
            },
            formatarData(data) {
                // Verifica se a data está no formato esperado
              
                
                // Divide a string de data em ano, mês e dia
                const [ano, mes, dia] = data.split('-');
                
                // Retorna a data formatada como "dd/mm/aaaa"
                return `${dia}/${mes}/${ano}`;
            },
            primeiramaiuscula(texto){
                return util.primeiramaiuscula(texto);
            },
            mtdformatarnomemenu(texto){
                const original = (texto || '').toString().trim();
                if (original === '' || original === '-'){
                    return original;
                }
                const normalizado = original.toLocaleLowerCase('pt-BR');
                return normalizado.charAt(0).toLocaleUpperCase('pt-BR') + normalizado.slice(1);
            },
            mtdlinkmenu(codop, linkOriginal){
                const links = {
                    '020Z.010Z': '/comercial/pedidos-venda',
                    '001Z.012Z': '/fiscal/predefinicao-fiscal',
                    '010Z.010Z': '/fiscal/notas-entrada',
                    '020Z.020Z': '/fiscal/notas-fiscais',
                    '030Z.010Z': '/financas/contas-receber',
                    '035Z.010Z': '/financas/lancamentos',
                    '035Z.020Z': '/financas/demonstrativo',
                    '010Z.050Z': '/pos-venda/garantias'
                };
                return links[codop] || linkOriginal;
            },
            mtddescricaoalternativa(descricaoOriginal){
                const texto = (descricaoOriginal || '').toString().trim();
                if (texto === '' || texto === '-'){
                    return texto;
                }
                const regras = [
                    { de: 'PEDIDOS DE', para: 'GESTÃO DE' },
                    { de: 'TÍTULOS', para: 'CONTAS' },
                    { de: 'LANÇAMENTOS', para: 'MOVIMENTAÇÕES' },
                    { de: 'CONFERÊNCIA', para: 'VALIDAÇÃO' },
                    { de: 'USUÁRIOS', para: 'ACESSOS' },
                    { de: 'RETORNOS', para: 'RETORNOS OPERACIONAIS' },
                    { de: 'PLANOS', para: 'PLANIFICAÇÕES' },
                    { de: 'RECIBOS', para: 'COMPROVANTES' },
                    { de: 'VEÍCULOS', para: 'FROTAS' },
                    { de: 'FORNECEDORES', para: 'PARCEIROS DE COMPRA' },
                    { de: 'CLIENTES', para: 'PARCEIROS COMERCIAIS' }
                ];
                let resultado = texto.toUpperCase();
                for (let i = 0; i < regras.length; i++){
                    resultado = resultado.replace(regras[i].de, regras[i].para);
                }
                return resultado;
            },
            mtddescricaomenu(codop, descricaoOriginal){
                const descricoes = {
                    '001Z': 'PARÂMETROS',
                    '002Z': 'REGISTROS DE NEGÓCIO',
                    '010Z': 'ESTOQUE E LOGÍSTICA',
                    '020Z': 'VENDAS',
                    '030Z': 'FINANÇAS INTEGRADAS',
                    '035Z': 'MOVIMENTAÇÕES FINANCEIRAS',
                    '040Z': 'ANÁLISES E RELATÓRIOS',
                    '050Z': 'FISCAL',
                    '020Z.010Z': 'GESTÃO DE PEDIDOS DE VENDA',
                    '001Z.012Z': 'PRÉ-DEFINIÇÃO FISCAL',
                    '010Z.010Z': 'NOTAS FISCAIS DE ENTRADA',
                    '020Z.020Z': 'NOTAS FISCAIS DE SAÍDA',
                    '030Z.010Z': 'CONTAS A RECEBER',
                    '035Z.010Z': 'LANÇAMENTOS FINANCEIROS',
                    '035Z.020Z': 'DEMONSTRATIVO FINANCEIRO',
                    '010Z.050Z': 'ASSISTÊNCIA E GARANTIAS'
                };
                if (descricoes[codop]){
                    return descricoes[codop];
                }
                if (codop && codop.split('.').length === 2){
                    return this.mtddescricaoalternativa(descricaoOriginal);
                }
                return descricaoOriginal;
            },
            mtdcodopmenuprincipal(codopSubmenu){
                if (codopSubmenu === '001Z.012Z' || codopSubmenu === '010Z.010Z' || codopSubmenu === '020Z.020Z'){
                    return '050Z';
                }
                if (codopSubmenu.indexOf('035Z.') === 0){
                    return '030Z';
                }
                const pos = codopSubmenu.indexOf('.');
                return pos > -1 ? codopSubmenu.substring(0, pos) : codopSubmenu;
            },
            mtdlistarelatoriosmenu(){
                return [
                    { codop: '040Z.010Z.005Z', menu: 'Auditoria de entradas', link: '/relatorios/estoque/notas-entrada?rid=4' },
                    { codop: '040Z.010Z.010Z', menu: 'Giro de itens', link: '/relatorios/estoque/movimento-produtos?rid=1' },
                    { codop: '040Z.010Z.020Z', menu: 'Valoriza estoque', link: '/relatorios/estoque/gerencial-estoque?rid=2' },
                    { codop: '040Z.010Z.030Z', menu: 'Planejamento de reposição', link: '/relatorios/estoque/sugestao-compras?rid=3' },
                    { codop: '040Z.010Z.040Z', menu: 'Reservas de estoque', link: '/relatorios/estoque/produtos-reservados?rid=5' },
                    { codop: '040Z.020Z.005Z', menu: 'Carteira de clientes', link: '/relatorios/vendas/vendas-clientes?rid=5' },
                    { codop: '040Z.020Z.010Z', menu: 'Performance de itens', link: '/relatorios/vendas/vendas-produtos?rid=1' },
                    { codop: '040Z.020Z.015Z', menu: 'Serviços faturados', link: '/relatorios/vendas/vendas-servicos?rid=4' },
                    { codop: '040Z.020Z.020Z', menu: 'Radar de faturamento', link: '/relatorios/vendas/mapa-vendas?rid=2' },
                    { codop: '040Z.020Z.030Z', menu: 'Operações de pdv', link: '/relatorios/vendas/movimentos-pdvs?rid=3' },
                    { codop: '040Z.020Z.040Z', menu: 'Premiação de vendedores', link: '/relatorios/vendas/comissao-vendedores?rid=6' },
                    { codop: '040Z.020Z.045Z', menu: 'Premiação de cobradores', link: '/relatorios/vendas/comissao-cobradores?rid=8' },
                    { codop: '040Z.020Z.050Z', menu: 'Catálogo de preços', link: '/relatorios/vendas/tabelas-precos?rid=7' },
                    { codop: '035Z.020Z', menu: 'Demonstrativo financeiro', link: '/financas/demonstrativo' }
                ];
            },
            mtdgarantirmenurelatorios(){
                const indiceRelatorios = util.getArrayIndexForKey(this.menuindividual, 'codop', '040Z');
                if (indiceRelatorios === -1){
                    this.menuindividual.push({
                        codop: '040Z',
                        menu: 'CENTRAL DE RELATÓRIOS',
                        habilita: 1,
                        chave: '["relatórios","analíticos","gerenciais"]',
                        icone: 'fa fa-bar-chart',
                        submenu: []
                    });
                }else{
                    this.menuindividual[indiceRelatorios].habilita = 1;
                }
            },
            mtdinjetarrelatoriosmenu(){
                this.mtdgarantirmenurelatorios();
                const indiceRelatorios = util.getArrayIndexForKey(this.menuindividual, 'codop', '040Z');
                if (indiceRelatorios === -1){
                    return;
                }
                const relatorios = this.mtdlistarelatoriosmenu();
                for (let i = 0; i < relatorios.length; i++){
                    const item = relatorios[i];
                    this.menuindividual[indiceRelatorios].submenu.push({
                        codop: item.codop,
                        menu: item.menu,
                        link: item.link,
                        habilita: util.opcaousuario(item.codop, this.$store.state.perfilusuario) ? 1 : 0
                    });
                }
            },
            mtdgarantirmenufiscal(){
                const indiceFiscal = util.getArrayIndexForKey(this.menuindividual, 'codop', '050Z');
                if (indiceFiscal === -1){
                    this.menuindividual.push({
                        codop: '050Z',
                        menu: 'FISCAL',
                        habilita: 1,
                        chave: '["fiscal","nota fiscal","nfe","nfce"]',
                        icone: 'fa fa-file-text-o',
                        submenu: []
                    });
                }
            },
            mtdlogoff() {
                util.logoff(this);
            },
            rtcarregardadosusuario() {
                let vself           = this;

                vself.pathfotovisualizar  = vself.$store.state.configpaths.pathimagens;
                vself.pathfotos           = vself.$store.state.configpaths.pathimagens;
                
                let loader          = vself.$loading.show();

                let parametros      = [
                    {parametro: 'op',           valor : 'dadosusuario'},
                    {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},
                    {parametro: 'idusuario',    valor : window.localStorage.getItem('idusuario')}
                ];
                let retorno     = util.reqaxios(parametros, 'post', window.localStorage.getItem('adrsrv')+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    const temaFilial = util.aplicartemafilial(response.data.filialpadrao.temafilial);
                    //carrega os dados da filial padrão do usuário
                    let payloadf = {
                        idcliente        : window.localStorage.getItem('idcliente'),//id do cliente no sac
                        idclientepadrao  : response.data.filialpadrao.idcliente,//id do consumidor padrao para emissao dos pedidos
                        codfil           : response.data.filialpadrao.codfil,
                        descfil          : response.data.filialpadrao.descfil,
                        fantasia         : response.data.filialpadrao.fantasia,
                        formulacustopro  : response.data.filialpadrao.formulacustoproduto,
                        logo             : response.data.filialpadrao.logo,
                        idestoque        : response.data.filialpadrao.idestoque,
                        descestoque      : response.data.filialpadrao.descestoque,
                        nomecliente      : response.data.filialpadrao.nomecliente,
                        idplano          : response.data.filialpadrao.idplano,
                        tipoplano        : response.data.filialpadrao.tipoplano,
                        descplano        : response.data.filialpadrao.descplano,
                        idtabela         : response.data.filialpadrao.idtabela,
                        percentrada      : response.data.filialpadrao.percentrada,
                        permitedesconto  : response.data.filialpadrao.permitedesconto,
                        temafilial       : temaFilial
                    };
                    
                    vself.$store.commit('MUDAR_DADOS_FILIAL',payloadf);
                    vself.$store.commit('MUDAR_TEMA_SISTEMA', temaFilial);



                    //Monta o menu do usuário
                    vself.menuapp           = [];
                    vself.menuindividual    = [];
                    vself.menuapp           = response.data.perfilusu;
                    vself.lstnotificacoes   = response.data.notificacoes;
                    //vself.qtdnotificacoes   = vself.lstnotificacoes.length;
                    vself.$store.commit('MUDAR_PERFIL_USUARIO',vself.menuapp);

                    for (var i = 0; i < vself.menuapp.length; i++) {
                        var m = vself.menuapp[i]['codop'];
                        var f = m.indexOf(".");
                        if (f === -1) {
                            if (m === '035Z') {
                                continue;
                            }
                            let menutmp = {
                                codop   : vself.menuapp[i]['codop'],
                                menu    : vself.mtddescricaomenu(vself.menuapp[i]['codop'], vself.menuapp[i]['descricao']),
                                habilita: vself.menuapp[i]['habilita'],
                                chave   : vself.menuapp[i]['chave'],
                                icone   : vself.menuapp[i]['icone'],
                                submenu : []
                            };
                            vself.menuindividual.push(menutmp);
                        }
                    }
                    vself.mtdgarantirmenufiscal();
                    for (var i = 0; i < vself.menuapp.length; i++) {
                        var m = vself.menuapp[i]['codop'];
                        var f = m.split(".");
                        if (f.length === 2) {
                            if (m.indexOf('040Z.') === 0){
                                continue;
                            }
                            var codop = vself.mtdcodopmenuprincipal(m);
                            let menuitem  = {
                                codop   : m,
                                menu    : vself.mtddescricaomenu(m, vself.menuapp[i]['descricao']),
                                link    : vself.mtdlinkmenu(m, vself.menuapp[i]['link']),
                                habilita: vself.menuapp[i]['habilita']
                            };
                            var ind = util.getArrayIndexForKey(vself.menuindividual, 'codop', codop);
                            if (ind > -1){
                                vself.menuindividual[ind]['submenu'].push(menuitem);
                            }
                        }
                    }
                    vself.mtdinjetarrelatoriosmenu();
                }).catch(function (response) {
                    loader.hide();
                    console.log(response);
                });
            },
            toggleNav(){
                if (this.isSidenavOpen){
                    this.closeNav();
                }else{
                    this.openNav();
                }
            },
            handleMiniHover(){
                if (!this.isMobileViewport){
                    this.openNav();
                }
            },
            handleSidenavMouseLeave(){
                if (!this.isMobileViewport){
                    this.closeNav();
                }
            },
            mtdatualizarsidebarlayout(){
                const sideNav = document.getElementById("mySidenav");
                if (!sideNav){
                    return;
                }

                if (this.isSidenavOpen){
                    sideNav.style.width = this.isMobileViewport ? "100vw" : "250px";
                    $('#dvconteudo-side-nav-mini').hide();
                    $('#dvconteudo-side-nav').stop(true, true).fadeIn(200);
                    document.body.classList.add('draco-sidenav-open');
                }else{
                    $('#dvconteudo-side-nav').hide();
                    if (this.isMobileViewport){
                        sideNav.style.width = "0";
                        $('#dvconteudo-side-nav-mini').hide();
                    }else{
                        sideNav.style.width = "50px";
                        $('#dvconteudo-side-nav-mini').show();
                    }
                    document.body.classList.remove('draco-sidenav-open');
                }
            },
            mtdatualizarviewport(){
                this.isMobileViewport = window.innerWidth <= 991;
                this.mtdatualizarsidebarlayout();
            },
            openNav(){
                this.isSidenavOpen = true;
                this.mtdatualizarsidebarlayout();
                this.mtdmontalstpesq();
                setTimeout(function(){
                    $('#edpesquisamenu').focus();
                },200);
            },
            closeNav(){
                this.isSidenavOpen = false;
                this.mtdatualizarsidebarlayout();
            },
            mtdmontalstpesq(){
                this.vcontpesqrapida     = '';
                this.lstpesquisa         = [];
                this.lstlistaresultado   = [];
                for (let i = 0; i < this.menuindividual.length; i++) {
                    const menu = this.menuindividual[i];
                    if (!menu || !Array.isArray(menu.submenu)){
                        continue;
                    }
                    for (let x = 0; x < menu.submenu.length; x++) {
                        const itemMenu = menu.submenu[x];
                        if (!itemMenu || parseInt(itemMenu.habilita) !== 1){
                            continue;
                        }
                        const chaves = [itemMenu.menu, menu.menu];
                        for (let y = 0; y < chaves.length; y++) {
                            this.lstpesquisa.push({
                                chave: chaves[y],
                                menu: itemMenu.menu,
                                link: itemMenu.link,
                                habilita: itemMenu.habilita
                            });
                        }
                    }
                }
            },
            mtddetalhesnotificacao(notificacao) {
                this.detnotificacao = notificacao;

                if(parseInt(this.detnotificacao.tipo)===3){
                    $('#mdldetnotificacaouser').modal('show');
                    var divconteudo = document.getElementById("conteudonotifexp");
                    divconteudo.innerHTML = "";
                    divconteudo.innerHTML = this.detnotificacao.conteudonotificacao;
                   
                }else{
                    $('#mdldetnotificacao').modal('show');
                }
          
            },            
            mtdlimparnotificacoes(idnotificacao){//se for 0 marca todas como lida
                let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},
                    {parametro: 'op',           valor : 'notificacaolida'},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'idnotificacao',valor : idnotificacao}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();                    
                    if ($.isNumeric(response.data)){
                        if (parseInt(idnotificacao) === 0){
                            vself.lstnotificacoes = [];
                        }else{
                            vself.lstnotificacoes.splice(util.getArrayIndexForKey(vself.lstnotificacoes, 'idnotificacao', idnotificacao), 1);
                        }
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                    vself.qtdnotificacoes= vself.lstnotificacoes.length + vself.lstBoletosDisp.length;
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                
            },
            mtddefinicoesusuario(){
                this.closeNav();
                this.asenha_antiga       = '';
                this.asenha_nova         = '';
                this.asenha_repete       = '';                
                $('#mddefinicoesusuario').modal('show');
            },
            mtdalterarsenhausuario(){
                let vself = this;
                if (vself.asenha_antiga === ''){
                    this.$toastr.w('Informe sua senha antiga!', 'Atenção!');
                    $('#edsenhaantigadef').focus();
                    return;
                }  
                if (vself.asenha_nova === ''){
                    this.$toastr.w('Informe sua nova senha!', 'Atenção!');
                    $('#edsenhanovadef').focus();
                    return;
                }                              
                if (vself.asenha_nova !== vself.asenha_repete){
                    this.$toastr.w('Senha e senha de confirmação não conferem!', 'Atenção!');
                    $('#edsenhaconfirmadef').focus();
                    return;
                }
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},
                    {parametro: 'op',           valor : 'defusuario'},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'pwold',        valor : vself.asenha_antiga},
                    {parametro: 'pwnew',        valor : vself.asenha_nova}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Senha alterada com sucesso!', 'Informação!');
                        $('#mddefinicoesusuario').modal('hide');
                        util.logoff(vself);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                $('#edsenhaantigadef').focus();
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                 
            }, 
            mtdselecionarimagemusuariodef(event){                
                let vself       = this;                 
                vself.arqimgselecionado = event.target.files[0];
                let loader      = vself.$loading.show();
                let localsalvar = vself.$store.state.configpaths.pathimgusuarios + vself.$store.state.filialpadrao.idcliente+'/'+vself.vdiretorioimagem;

                let parametros      = [
                    {parametro: 'arquivo',          valor  : vself.arqimgselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : vself.arqimgselecionado.name}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.inf)){
                        vself.vfoto                = localsalvar+'/'+vself.arqimgselecionado.name;                        
                        vself.arqimgselecionado    = null;
                        vself.$toastr.s('Imagem enviada com sucesso!', 'Informação!');
                        $('#ipselecionarimgusuariodef').val('');

                        let loaderx = vself.$loading.show();
                        let parametros      = [
                            {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},
                            {parametro: 'op',           valor : 'atzfoto'},
                            {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                            {parametro: 'foto',         valor : vself.vfoto}
                        ];
                        let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                        retorno.then(function (response) {
                            loaderx.hide();
                            if (!$.isNumeric(response.data)){
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                            }else{
                                $('#mddefinicoesusuario').modal('hide');
                                util.logoff(vself);                             
                            }
                        }).catch(function (response) {
                            loaderx.hide();
                            vself.$toastr.e('Erro ao enviar foto. Descrição do erro: '+response.message, 'Erro!');
                        });
                    }else{
                        loader.hide();
                        vself.vfoto             = '';                        
                        vself.arqimgselecionado = null;
                        $('#ipselecionarimgusuariodef').val('');
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }                   
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                    vself.vfoto             = '';                        
                    vself.arqimgselecionado = null;
                    $('#ipselecionarimgusuariodef').val('');
                });                
            },
            mtdcentralnotificacao(){
                $('#mdcentralntificacao').modal('show');
            },
            mtdverificaliberacaosistema(){
                let vself  = this; 
                let idclisac = vself.$store.state.filialpadrao.idcliente !== null ? vself.$store.state.filialpadrao.idcliente : window.localStorage.getItem('idcliente');
          
            },
            mtdverificademo(){
                let vself  = this; 
                let idclisac = vself.$store.state.filialpadrao.idcliente !== null ? vself.$store.state.filialpadrao.idcliente : window.localStorage.getItem('idcliente');
                if (idclisac !== null){                
                    let loader = vself.$loading.show();
                    let parametros      = [
                        {parametro: 'op',           valor : 'verificademo'},
                        {parametro: 'idcliger',    valor : idclisac}//id do cliente no sac
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                    retorno.then(function (response) {
                        loader.hide();
                        console.log("inicio")
                        if($.isNumeric(response.data.status)){
                           
                            switch (parseInt(response.data.status) ) {
                                
                                case 1:
                                    vself.qtdnotificacoes = vself.lstnotificacoes.length + 1;
                                    vself.titulopagar     = response.data.titulo;
                                    vself.$toastr.i("Você tem uma fatura disponivel, vide as notificações", 'Atenção!');
                                    break;
                                case 2:
                                    vself.qtdnotificacoes = vself.lstnotificacoes.length + 1;
                                    vself.titulopagar     = response.data.titulo;
                                    $('#mdlregularizar').modal('show');
                                    break;
                                    
                                case 3:
                                    vself.qtdnotificacoes = vself.lstnotificacoes.length + 1;
                                    vself.titulopagar     = response.data.titulo;
                                    vself.$toastr.w("Não identificamos o pagamento da sua mensalidade", 'Atenção!');
                                    vself.$toastr.w("Seu serviço pode ser cortado dentro de 5 dias ", 'Atenção!');
                                    $('#mdlembretepagamento').modal('show');
                                    break;    
                                case 4:
                                   
                                    $('#mdfimdemo').modal('show');
                                    break;    
                            
                              
                            }
                        }else{
                             vself.$toastr.w(response.data, 'Atenção!');
                        }
                    }).catch(function (response) {
                        loader.hide();                     
                    });    
                }
            },
        },
        mounted: function () { 
            let vself = this;       
            vself.pathfotos  = vself.$store.state.configpaths.pathimagens;
            this.mtdverificademo()
            vself.resizeHandler = function(){
                vself.mtdatualizarviewport();
            };
            window.addEventListener('resize', vself.resizeHandler);
            $('#mdldetnotificacao').on('hidden.bs.modal', function () {
                vself.mtdlimparnotificacoes(vself.detnotificacao.idnotificacao);
            }); 
            $('#mdldetnotificacaouser').on('hidden.bs.modal', function () {
                vself.mtdlimparnotificacoes(vself.detnotificacao.idnotificacao);
            }); 
            $('#mddefinicoesusuario').on('shown.bs.modal', function () {
                $('#edsenhaantigadef').focus();
            }); 
            vself.mtdatualizarviewport();
            vself.closeNav();
        },
        beforeDestroy(){
            if (this.resizeHandler){
                window.removeEventListener('resize', this.resizeHandler);
            }
            document.body.classList.remove('draco-sidenav-open');
        },
        computed: {
            filial() {
                return this.$store.state.filialpadrao;
            },
            logoFilialMenu(){
                const logoFilial = (this.$store.state.filialpadrao.logo || '').toString().trim();
                const pathBase = (this.$store.state.configpaths.pathimagens || this.pathfotos || '').toString();
                if (logoFilial !== '' && pathBase !== ''){
                    return pathBase + logoFilial;
                }
                return require('../assets/logosis.png');
            },
            logoFilialMenuMini(){
                const logoFilial = (this.$store.state.filialpadrao.logo || '').toString().trim();
                const pathBase = (this.$store.state.configpaths.pathimagens || this.pathfotos || '').toString();
                if (logoFilial !== '' && pathBase !== ''){
                    return pathBase + logoFilial;
                }
                return require('../assets/logo.png');
            },
            usuario(){
                this.rtcarregardadosusuario();                        
                return this.$store.state.usuario;                               
            },
            situacaosidenav(){             
                return this.$store.state.sidenav.fechar;                
            },
            verificarlib(){
                return this.$store.state.verificalib.verificar;
            }            
        },
        watch:{
            vcontpesqrapida(val) {
                if (val.toUpperCase() !== ''){
                    this.lstlistaresultado = $.grep(this.lstpesquisa, function(element){
                        return element.chave.toUpperCase().indexOf(val.toUpperCase()) !== -1;
                    });
                }else{
                    this.lstlistaresultado = [];
                }
            },
            situacaosidenav(val){
                if (val === true){
                   this.closeNav();
					let payloads = {
						fechar    : false			
					};
					this.$store.commit('SIDE_NAV_CHANGE',payloads);                                       
                }
            },
            usuario(val){
                if (parseInt(val.definirsenhalogin) === 1){
                    this.mtddefinicoesusuario();
                }
                this.mtdverificaliberacaosistema();
    
            },
            verificarlib(val){
                if (val === true){
                   this.mtdverificaliberacaosistema(); 
                }
            }
        }
    };
</script>
<style>
    .Azul{
        color: #4250f2;
    }
    .Amarelo{
        color: #ffbc00;
    }
    .Verde{
        color: #0acf97;
    }
    .Vermelho{
        color: #f82b54;
    }
	    .btn-menu-toggle{
	        color: var(--draco-nav-text, #b8bfce);
	        font-size: 0.95rem;
	        padding: 0.1rem 0.3rem;
	        border: 0 !important;
	        box-shadow: none !important;
	    }
	    .btn-menu-toggle:hover,
	    .btn-menu-toggle:focus{
	        color: var(--draco-nav-accordion-hover, #a98bde);
	        text-decoration: none;
	    }
	    #dvtop{
	        background: var(--draco-nav-bg, #31353D);
	        border-bottom: 1px solid rgba(255, 255, 255, 0.08);
	    }
		    .draco-topbar{
		        background: var(--draco-nav-bg, #31353D) !important;
		        border-radius: 0;
		        min-height: 42px;
            height: 42px;
            padding: 0 0.65rem;
		    }
        #navbarmenu .navbar-text{
            margin: 0 !important;
            padding-top: 0 !important;
            padding-bottom: 0 !important;
            height: 42px;
            display: inline-flex;
            align-items: center;
        }
        .draco-top-divider{
            height: 2px;
            background: linear-gradient(90deg, var(--draco-purple, #593196) 0%, var(--draco-nav-accordion-hover, #a98bde) 100%);
            opacity: 0.9;
        }
	    .draco-sidenav-backdrop{
	        position: fixed;
	        inset: 0;
	        background: rgba(0, 0, 0, 0.35);
	        z-index: 98;
    }
    #mySidenav{
        background: var(--draco-nav-bg, #31353D) !important;
        z-index: 99;
    }
    .sidenav-logo{
        width: 100%;
        max-width: 180px;
        max-height: 74px;
        object-fit: contain;
        display: block;
        margin: 0 auto;
    }
    .sidenav-logo--mini{
        max-width: 54px;
        max-height: 54px;
    }
    .dv-borda-bottom{
        border-bottom: 1px solid #3a3f48;
    }
	    .dados-usuario{
	        padding: 15px 0 15px 0px;
	    }
			    #navbarmenu{
			        position: relative;
			        border-bottom: 1px solid rgba(255, 255, 255, 0.06);
                min-height: 42px;
                padding-top: 0;
                padding-bottom: 0;
                padding-right: 0.95rem;
			    }
		    #fantasia-filial{
		        position: absolute;
		        left: 50%;
		        transform: translateX(-50%);
	        width: calc(100% - 190px);
	        text-align: center;
	        padding: 0 8px;
	        margin: 0;
	        overflow: hidden;
	        text-overflow: ellipsis;
		        white-space: nowrap;
		        color: var(--draco-nav-text, #e5e9f2);
		        font-weight: 600;
                font-size: 0.9rem;
                line-height: 42px;
		        pointer-events: none;
		    }
	    @media (max-width: 991px) {
	        #fantasia-filial{
	            width: calc(100% - 140px);
	            font-size: 13px;
	        }
	    }
	    @media (max-width: 575px) {
	        #fantasia-filial{
	            width: calc(100% - 120px);
	        }
	    }
    #nome-empresa{
        width: 175px;
        text-transform: uppercase;
        font-size: 16px;
        color: var(--draco-nav-text, #b8bfce);
        padding-bottom: 5px;;
    }
    #img-foto-usuario{
        border: 1px solid #3a3f48;
        border-radius: 5px;
        width: 50px !important;
        height: 50px !important;
    }
    #nome-usuario{
        margin-top: 5px;
        font-size: 16px;
        color: var(--draco-nav-text, #b8bfce);
    }
    #grupo-usuario{
        margin-top: -5px;
        font-size: 12px;
        color: var(--draco-nav-text, #b8bfce);
        font-weight: lighter;
    }    
    #grupo-lista-menu{
        cursor: pointer;
        list-style-type: none;
        padding-left: 0px;
    }
	    #grupo-lista-menu>li>a{
	        color: var(--draco-nav-text, #b8bfce) !important; 
	        background: transparent;
	        font-size: 15px;               
	        padding: 10px;
	        padding-left: 30px;
	        transition: 0.2s;
	    }    
	    #grupo-lista-menu>li>a:hover,
	    #grupo-lista-menu>li>a[aria-expanded="true"]{
	        color: var(--draco-nav-accordion-text, var(--draco-nav-text, #b8bfce)) !important;
	        background: var(--draco-nav-accordion-bg, #3a3f48);
	        text-shadow: 0px 0px 8px var(--draco-nav-accordion-hover, #a98bde);
	    }
	    .grupo-lista-submenu{
	        background: var(--draco-nav-accordion-bg, #3a3f48);
	        cursor: pointer;
	        list-style-type: none;
	        padding-left: 55px;
	    }
	    .grupo-lista-submenu>li>a{
	        color: var(--draco-nav-accordion-text, var(--draco-nav-text, #b8bfce)); 
	        font-size: 15px;               
	        padding: 5px;        
	    }    
	    .grupo-lista-submenu>li>a:hover{
	        color: var(--draco-nav-accordion-hover, #a98bde);
	        text-shadow: 0px 0px 10px var(--draco-nav-accordion-hover, #a98bde);        
	    }     
	    .grupo-lista-pesquisa{
	        background: var(--draco-nav-accordion-bg, #3a3f48);
	        cursor: pointer;
	        list-style-type: none;
	        padding-left: 5px;
	        padding-right: 5px;
	    }
	    .grupo-lista-pesquisa>li>a{
	        color: var(--draco-nav-accordion-text, var(--draco-nav-text, #b8bfce)); 
	        font-size: 12px;               
	        padding: 5px;        
	    }    
	    .grupo-lista-pesquisa>li>a:hover{
	        color: var(--draco-nav-accordion-hover, #a98bde);
	        text-shadow: 0px 0px 10px var(--draco-nav-accordion-hover, #a98bde);        
	    }
    .icone-rotate{
        font-size: 10px;
        float: right;
        margin-right: 10px;
        margin-top: 5px;
        transition: 0.5s;
    }
    .grupo-lista-submenu>li>a>i{
        font-size: 8px;
        position: relative;
        top: -2px;
    }
    [data-toggle="collapse"][aria-expanded="true"] > .icone-rotate{
            -webkit-transform: rotate(90deg);
            -moz-transform: rotate(90deg);
            -ms-transform: rotate(90deg);
            -o-transform: rotate(90deg);
            transform: rotate(90deg);
            transition: 0.5s;            
    }       
    #edpesquisamenu, #btpesquisarmenu{
        background: #3a3f48;
        border-color: transparent;
        box-shadow: none;  
        color: var(--draco-nav-text, #b8bfce);
    }
    .closebtn{
        cursor: pointer;
        position: absolute;
        left: 85%;
        color: #818896;
        top: -8px;
        font-size: 20px;   
    }
    .closebtn:hover{
        color: #b8bfce;
        text-shadow: 0px 0px 2px #b8bfce;        
    }
    .icone-menu{
        font-size: 18px;
        margin-right: 10px;
    }   
		    #lst-icones-menu-nav{
		        margin: 0 10px 0 0;
            padding-left: 0;
            display: flex;
            align-items: center;
	    }
	    #lst-icones-menu-nav > li{
	        display: inline-flex;
	        align-items: center;
	        margin-left: 0;
	    }
		    @media (max-width: 991px) {
		        #lst-icones-menu-nav{
		            padding-left: 0;
		            margin: 0 8px 0 0;
		        }
		    }
		    .icone-menu-bar{
		        transition: 0.2s; 
		        cursor: pointer;
		        font-size: 15px;
		        margin-left: 8px;
		        color: var(--draco-nav-text, #b8bfce);
		    }     
	    .icone-menu-bar:hover{ 
	        transition: 0.2s;  
	        color: var(--draco-nav-accordion-hover, #a98bde);
	        text-shadow: 0px 0px 5px var(--draco-nav-accordion-hover, #a98bde);               
	    }
    .drop-notificacoes{
        border: 0px!important;
        left: -240px!important;
        border: 0px!important;
        padding: 0px!important;
        width: 300px !important;
        top: 40px!important;        
    }
    .drop-mensagens{
        border: 0px!important;
        left: -240px!important;
        border: 0px!important;
        padding: 0px!important;
        width: 300px !important;
        top: 40px!important;        
    }
    .badge-notfusu{
        font-size: 10px!important;
        min-width: 20px;
        border-radius: 10px;
        position: absolute;
        top: -5px;
        left: 30px;
    }
    @media (min-width: 992px) {
        .animate {
            animation-duration: 0.3s;
            -webkit-animation-duration: 0.3s;
            animation-fill-mode: both;
            -webkit-animation-fill-mode: both;
        }
    }

    @keyframes slideIn {
        0% {
            transform: translateY(1rem);
            opacity: 0;
        }
        100% {
            transform:translateY(0rem);
            opacity: 1;
        }
        0% {
            transform: translateY(1rem);
            opacity: 0;
        }
    }

    @-webkit-keyframes slideIn {
        0% {
            -webkit-transform: transform;
            -webkit-opacity: 0;
        }
        100% {
            -webkit-transform: translateY(0);
            -webkit-opacity: 1;
        }
        0% {
            -webkit-transform: translateY(1rem);
            -webkit-opacity: 0;
        }
    }

    .slideIn {
    -webkit-animation-name: slideIn;
    animation-name: slideIn;
    }

.tit-notificacao{
    position: absolute;
    font-size: 15px;
    color: #6c757d;
    top: 10px;
    left: 65px;
    max-width: 220px; 
    overflow: hidden; 
    text-overflow: ellipsis; 
    white-space: nowrap;    
}
.data-notificacao{
    font-size: 10px;
    font-weight: 500;
    color: #98a6ad;
    position: absolute;
    left: 65px;
    top: 35px;  
}
.img-usuario-notificacao{
    width: 35px!important;
    height: 35px!important;
    margin-left: -5px!important;
}
.img-usuario-notificacao-esp{
    width: 20px!important;
    height: 20px!important;
    margin-left: -5px!important;
}
#limpar-notificacao{
    float: right;
    font-size: 12px;
    margin-top: 2px;
    cursor: pointer; 
    transition: 0.5s;   
}
#limpar-notificacao:hover{
    filter: brightness(80%)!important;
    transition: 0.5s;
}
#img-usuario-def{
    position: relative;
    background-color: #ddd;
    border-radius: 100%;
    height: 220px;
    object-fit: cover;
    width: 220px;
    cursor: pointer;
}
.icon-validade-cert{
    font-size: 45px;
    color: #f82b54;
}
/* #dvalertasistema{
    display: block;
    z-index: 97;
    margin-top: 65px;
    margin-left: 15px;
    margin-right: 15px;
    margin-bottom: -60px;
} */
    @media (max-width: 991px) {
        #mySidenav{
            width: 0;
        }
        #dvconteudo-side-nav-mini{
            display: none !important;
        }
        #dvconteudo-side-nav{
            display: block !important;
        }
    }
    @media (min-width: 992px) {
        .draco-sidenav-backdrop{
            display: none !important;
        }
    }


		  .bolinha-notificacao {
		        background-color: var(--draco-purple, #593196) !important;
		        color: white;
		        width: 26px;
		        height: 26px;
	        border-radius: 50%;
	        display: flex;
	        align-items: center;
		        justify-content: center;
		        font-size: 14px;
		    }
    .bolinha-home{
        background-color: #2f7f4f !important;
        color: #ffffff;
        width: 26px;
        height: 26px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.14), 0 4px 10px rgba(20, 32, 24, 0.28);
        transition: transform 0.16s ease, filter 0.16s ease;
    }
    .icone-menu-bar:hover .bolinha-home{
        transform: translateY(-1px);
        filter: brightness(1.08);
    }
    .draco-side-shortcuts{
        padding: 10px 15px;
    }
    #mySidenav .draco-side-home-link{
        display: flex;
        align-items: center;
        gap: 8px;
        color: #d9dfec !important;
        background: rgba(89, 49, 150, 0.34);
        border: 1px solid rgba(169, 139, 222, 0.36);
        border-radius: 10px;
        font-size: 0.9rem !important;
        font-weight: 700;
        padding: 8px 10px !important;
        line-height: 1.1 !important;
        text-decoration: none !important;
        transition: all 0.18s ease;
    }
    .draco-side-home-link:hover{
        background: rgba(89, 49, 150, 0.52);
        color: #ffffff !important;
        transform: translateY(-1px);
    }
    #dvconteudo-side-nav-mini .draco-mini-home-item{
        list-style-type: none;
    }
    #dvconteudo-side-nav-mini .draco-mini-home-link{
        position: relative;
        display: block;
        padding: 8px 0 8px 17px !important;
        color: #d9dfec !important;
        text-decoration: none !important;
    }
    #dvconteudo-side-nav-mini .draco-mini-home-link .icone-menu{
        position: relative;
        z-index: 2;
        color: #ffffff !important;
        margin-right: 0;
    }
    #dvconteudo-side-nav-mini .draco-mini-home-link::before{
        content: "";
        position: absolute;
        left: 11px;
        top: 50%;
        width: 28px;
        height: 28px;
        border-radius: 9px;
        transform: translateY(-50%);
        background: linear-gradient(125deg, #2f7f4f 0%, #43a06a 100%);
        box-shadow: 0 6px 14px rgba(21, 45, 32, 0.3);
    }
    #dvconteudo-side-nav-mini .draco-mini-home-link:hover::before{
        filter: brightness(1.08);
    }
    .draco-side-home-link,
    .draco-mini-home-link{
        text-shadow: none !important;
    }
    #navbarmenu #lst-icones-menu-nav{
        align-items: center !important;
        height: 42px !important;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        padding-top: 0 !important;
    }
    #navbarmenu #lst-icones-menu-nav > li{
        position: relative;
        top: 0 !important;
        height: 42px !important;
        display: inline-flex !important;
        align-items: center !important;
    }
    #navbarmenu #lst-icones-menu-nav > li .icone-menu-bar{
        display: inline-flex !important;
        align-items: center !important;
        line-height: 1 !important;
        margin-top: 0 !important;
    }
    #navbarmenu #lst-icones-menu-nav > li .bolinha-notificacao{
        position: relative !important;
        top: -1px !important;
    }
  
</style>
